export const INTL_LOCALES = ["en-US", "fr-FR"] as const;
export type IntlLocal = (typeof INTL_LOCALES)[number];

export const DEFAULT_INTL_LOCALE: IntlLocal = "en-US";
